// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","466":"component---src-pages-docs-mdx-slug-js"}[chunkId] + "-" + {"125":"334ef3cd155cf6b88851","293":"60d6db3c8cf323e19a4b","466":"08ba4919fdce7981ef85"}[chunkId] + ".js";
};